import {
  Layout,
  Spin,
  PageHeader,
  Breadcrumb,
  Row,
  Col,
  Button,
  Icon,
  Table,
  Tooltip,
} from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import { Constant } from "../../config";
import axios from "axios";
import Moment from "react-moment";
import "./RevisionPrice.css";
import {
  setRevisionPriceInfo,
  setRevisionPriceRate,
  setRevisionLogs,
  setNextRevisionInfo,
} from "../../store/actions/revisionPrice";
import RevisionChangeLogModal from "./Modals/RevisionChangeLog";
import RevisionNoteModal from "./Modals/RevisionNote";
import { checkRolePermission } from "../../services/permission";
import { permissionName, permissionType } from "../../config/permission";

const { Content } = Layout;
const routes = () => [
  {
    path: "/",
    breadcrumbName: "Home",
  },
  {
    path: "/revision-price/listing",
    breadcrumbName: "Revision Price",
  },
  {
    path: "",
    breadcrumbName: "Revision Listing",
  },
];

class RevisionListing extends Component {
  state = {
    data: [],
    pagination: {},
    loading: false,
    revisionRow: {},
    enableReviseNoteModal: false,
    enableChangeLogsModal: false,
    revisionId: null,
    changeLogsData: {},
    loadingLogs: false,
    hasMoreLogs: true,
    changeLogsTotal: 0,
    currentVersion: 0,
    revisionChangeModalVisible: false,
    versionString: "",
    currentData: {},
    revisionNoteModalVisible: false,
    canCreate: false,
    canUpdate: false,
  };

  columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        return text || "-";
      },
      align: "center",
    },
    {
      title: "Version Code",
      dataIndex: "version",
      key: "version",
      render: (text, record) => {
        return <span>{String(record.version).padStart(4, "0")}</span>;
      },
      align: "center",
    },
    {
      title: "Create",
      dataIndex: "created_date",
      key: "created_date",
      render: (text, record) => {
        if (record.id === 1) {
          return "Default Version";
        } else {
          return (
            <Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">
              {record.created_date}
            </Moment>
          );
        }
      },
      align: "center",
    },
    {
      title: "Customers",
      dataIndex: "total_member",
      key: "total_member",
      render: (text, record) => {
        return <span>{text || "-"}</span>;
      },
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        if (record.next_version) {
          return (
            <div style={{ fontSize: 12, color: "grey" }}>
              <div>
                Update to {String(record.next_version).padStart(4, "0")}
              </div>
              <div>
                <Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">
                  {record.next_version_created_date}
                </Moment>
              </div>
            </div>
          );
        } else {
          return <span className="active-color">Active</span>;
        }
      },
      align: "center",
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      render: (text, record) => {
        if (!text) return "-";
        return (
          <span
            className="text-link"
            onClick={() => this.triggerNoteModal(record)}
          >
            View Note
          </span>
        );
      },
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <div style={{ textAlign: "right" }}>
            <Button
              shape="round"
              icon="snippets"
              style={{ fontSize: 12 }}
              onClick={() => this.triggerChangeLogModal(record)}
            >
              Change Log
            </Button>
            &nbsp;
            {this.state.canUpdate && (
              <Tooltip placement="top" title="Edit">
                <Button
                  shape="circle"
                  icon="edit"
                  onClick={() => this._editRevision(record.id)}
                />
                &nbsp;
              </Tooltip>
            )}
            <Tooltip placement="top" title="View">
              <Button
                shape="circle"
                icon="eye"
                onClick={() => this._viewRevision(record.id)}
              />
            </Tooltip>
          </div>
        );
      },
      align: "center",
    },
  ];

  componentWillMount() {
    this.props.fetchMenuAction("revision-price", "revision-listing");
    this.setState({ loading: true });
    const canCreate = checkRolePermission(
      permissionName.REVISION_PRICE,
      permissionType.CREATE
    );
    const canUpdate = checkRolePermission(
      permissionName.REVISION_PRICE,
      permissionType.UPDATE
    );
    this.setState({
      canCreate,
      canUpdate,
    });
  }

  async componentDidMount() {
    await this._fetchRevisionList();
    await this._fetchCountryList();
    this._resetStore();
    this.setState({
      loading: false,
    });
  }

  handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this._fetchRevisionList(pager.current, pagination.pageSize);
  };

  _resetStore = () => {
    this.props.setRevisionPriceInfo({
      version: null,
      name: "",
      note: "",
    });
    this.props.setRevisionPriceRate({
      rate: [],
    });
    this.props.setRevisionLogs({
      logs: [],
    });
    this.props.setNextRevisionInfo({
      version: "",
      name: "",
      nextVersion: "",
    });
  };

  _fetchRevisionList = async (
    page = 1,
    limit = 10,
    filter = { order_by: "id", order: "asc" }
  ) => {
    const url = Constant.REVISION_PRICE_API;
    for (const key in filter) {
      if (!filter[key]) {
        delete filter[key];
      }
    }
    const options = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        page,
        limit,
        ...filter,
      },
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    let pagination = { ...this.state.pagination };
    pagination.size = "small";
    let d = [];

    if (!resp.data) {
    } else if (resp.data.error) {
    } else {
      d = resp.data.data;
      pagination.total = resp.data.total_rows;
      this.setState({
        loading: false,
        data: d,
        pagination,
      });
    }
  };

  _createRevision = () => {
    this.props.history.push("/revision-price/create");
  };

  _editRevision = (id) => {
    this.props.history.push(`/revision-price/edit/${id}`);
  };

  _viewRevisionNote = (record) => {
    this.setState({
      revisionRow: record,
      enableReviseNoteModal: true,
    });
  };

  _viewRevision = (id) => {
    this.props.history.push(`/revision-price/${id}`);
  };

  triggerNoteModal = (record) => {
    this.setState({
      revisionNoteModalVisible: true,
      currentVersion: record.id,
      versionString: record.name,
      currentData: record,
    });
  };

  triggerOnCloseNoteModal = () => {
    this.setState({
      revisionNoteModalVisible: false,
    });
  };

  triggerChangeLogModal = (record) => {
    this.setState({
      revisionChangeModalVisible: true,
      currentVersion: record.id,
      versionString: record.name,
      currentData: record,
    });
  };

  triggerOnCloseRevisionChange = () => {
    this.setState({
      revisionChangeModalVisible: false,
    });
  };

  cbEdit = () => {
    this.props.history.push(
      `/revision-price/edit/${this.state.currentVersion}`
    );
  };

  async _fetchCountryList(page = 1, limit = -1) {
    let url = Constant.COUNTRY_API + "?page=" + page + "&limit=" + limit;

    let opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    this.setState({
      countryList: resp.data.data,
    });
  }

  render() {
    let propsTable = {
      columns: this.columns,
      dataSource: this.state.data,
      rowKey: (record) => record.id,
      pagination: this.state.pagination,
      loading: this.state.loading,
      onChange: this.handleTableChange,
    };

    return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          {routes(this.state.versionString).map((route) => (
            <Breadcrumb.Item>
              {route.path ? (
                <a href={route.path}>{route.breadcrumbName}</a>
              ) : (
                route.breadcrumbName
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Revision Listing</h2>}
        />
        <Layout className="my-layout">
          <Content className="main-container">
            <div className="main-container-inner">
              <Row type="flex">
                <Col span={12}>
                  <h3>Sell Price Version</h3>
                </Col>
                <Col span={12} className="text-right">
                  {this.state.canCreate && (
                    <Button
                      type="primary"
                      onClick={() => this._createRevision()}
                    >
                      <Icon type="plus" />
                      Create New Revision
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
            <Spin spinning={this.state.loading}>
              <Table scroll={{ x: "max-content" }} {...propsTable} />
            </Spin>
          </Content>
        </Layout>
        {this.state.revisionNoteModalVisible && (
          <RevisionNoteModal
            visible={this.state.revisionNoteModalVisible}
            data={this.state.currentData}
            onCancel={this.triggerOnCloseNoteModal}
            name={this.state.versionString}
            canEdit={this.state.canUpdate}
            editCb={this.cbEdit}
            viewMore={() => this._viewRevision(this.state.currentData.id)}
            fromTable={true}
          />
        )}
        {this.state.revisionChangeModalVisible && (
          <RevisionChangeLogModal
            visible={this.state.revisionChangeModalVisible}
            data={this.state.currentData}
            onCancel={this.triggerOnCloseRevisionChange}
            name={this.state.versionString}
            countryList={this.state.countryList}
            canEdit={this.state.canUpdate}
            editCb={this.cbEdit}
            viewMore={() => this._viewRevision(this.state.currentData.id)}
            fromTable={true}
          />
        )}
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
    setRevisionPriceInfo: ({ version, name, note }) =>
      dispatch(setRevisionPriceInfo({ version, name, note })),
    setRevisionPriceRate: ({ rate }) =>
      dispatch(setRevisionPriceRate({ rate })),
    setRevisionLogs: ({ logs }) => dispatch(setRevisionLogs({ logs })),
    setNextRevisionInfo: ({ version, name, nextVersion }) =>
      dispatch(setNextRevisionInfo({ version, name, nextVersion })),
  };
};

export default connect(null, mapDispatchToProps)(RevisionListing);



// WEBPACK FOOTER //
// ./src/containers/RevisionPrice/index.js